import { ThemeProvider } from "@mui/material";
import { Theme } from "./helpers/Theme";
import { Navigation } from "./navigation";

export const App = () => {
  return (
    <ThemeProvider theme={Theme}>
      <Navigation />
    </ThemeProvider>
  );
};
